import React from 'react';
import classNames from 'classnames';
import { IconSelectionSet, newIconSelectionSet } from '@decisions/server/DecisionsFramework/Design/Properties';
// import './SelectByIconEditorChip.less'

interface ISelectByIconEditorChipProps extends React.HTMLProps<HTMLButtonElement> {
  value: string;
  icons: Map<string, IconSelectionSet>;
  hoveredValue: string;
  selectedValue: string;
}

const getClassName = (isActive = false, isHovered = false) =>
  classNames('dp-select-by-icon-editor__chip', {
    'dp-select-by-icon-editor__chip--hovered': isHovered && !isActive,
    'dp-select-by-icon-editor__chip--active': isActive,
  });

/**
 * A chip component for an editor to pick string values by choosing an icon, not just a dropdown/radio.
 *
 * Copyright (c) 2021 Decisions All Rights Reserved
 */
export function SelectByIconEditorChip({
  selectedValue: activeIndex,
  hoveredValue,
  icons: allIcons,
  value,
  selectedValue,
  ...buttonProps
}: ISelectByIconEditorChipProps) {
  const isActive = value === selectedValue;
  const isHovered = value === hoveredValue;
  const icons = allIcons.get(value) ?? newIconSelectionSet();
  return (
    <button className={getClassName(isActive, isHovered)} {...buttonProps} id={value} type="button">
      {/* show/hide with inline styles instead of changing URL to avoid any flicker due to download lag */}
      <img
        src={`${virtualPath}${icons.Icon}`}
        alt={value}
        className="dp-select-by-icon-editor__chip-icon"
        style={{ display: !(isActive || isHovered) ? 'block' : 'none' }}
      />
      <img
        src={`${virtualPath}${icons.Hovered}`}
        alt={value}
        className="dp-select-by-icon-editor__chip-icon"
        style={{ display: isHovered && !isActive ? 'block' : 'none' }}
      />
      <img
        src={`${virtualPath}${icons.Active}`}
        alt={value}
        className="dp-select-by-icon-editor__chip-icon"
        style={{ display: isActive ? 'block' : 'none' }}
      />
      <span className="dp-select-by-icon-editor__chip-label">{value}</span>
    </button>
  );
}
